import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {DataTable} from '@/components/data-table'
import {ListEmptyState} from '@/components/section-card'
import {PaginationBar} from '@/components/ui/pagination-bar'
import {useColumnasCumplimiento} from '@/components/cumplimiento-fila'
import {
  CUMPLIMIENTO_POR_PAGINA,
  type BloqueCumplimiento,
  type FilaCumplimiento,
} from '@/hooks/empresa/cumplimiento/use-cumplimiento'

/** El bloque sin filas nunca se esconde (D11) y conserva su `data-testid`, que lee el e2e. */
export function BloqueTab({
  bloque,
  sinPerfil,
  puedeOperar,
  puedeFirmar,
  puedeCustodiar,
  onAccion,
  onDescartar,
}: {
  bloque: BloqueCumplimiento
  sinPerfil: boolean
  puedeOperar: boolean
  puedeFirmar: boolean
  puedeCustodiar: boolean
  onAccion: (fila: FilaCumplimiento) => void
  onDescartar: (fila: FilaCumplimiento) => void
}) {
  const {t} = useTranslation()
  const [page, setPage] = useState(1)
  const columnas = useColumnasCumplimiento({puedeOperar, puedeFirmar, puedeCustodiar, onAccion, onDescartar})
  const filas = bloque.filas
  // Un acto puede reescribir la hoja: sin este tope una página que ya no existe pinta vacía.
  const ultima = Math.max(1, Math.ceil(filas.length / CUMPLIMIENTO_POR_PAGINA))
  const actual = Math.min(page, ultima)
  const desde = (actual - 1) * CUMPLIMIENTO_POR_PAGINA
  return (
    <section className="space-y-1" data-testid={`cumplimiento-bloque-${bloque.bloque}`}>
      <DataTable
        columns={columnas}
        rows={filas.slice(desde, desde + CUMPLIMIENTO_POR_PAGINA)}
        rowKey={(fila) => fila.requisito_id}
        rowTestId={(fila) => `cumplimiento-fila-${fila.nombre}`}
        emptyState={
          <div data-testid={`cumplimiento-vacio-${bloque.bloque}`}>
            <ListEmptyState title={sinPerfil ? t('cumplimiento.bloqueSinPerfil') : t('cumplimiento.bloqueVacio')} />
          </div>
        }
      />
      {filas.length > 0 && (
        <PaginationBar page={actual} pageSize={CUMPLIMIENTO_POR_PAGINA} total={filas.length} onPageChange={setPage} />
      )}
    </section>
  )
}
